module.exports = __webpack_public_path__ + "img/6.53f98e92.png";